/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';
import DisplayAmount from "../../shared/DisplayAmount";

const BatchUpdateStatusConfirmModal: React.FC<{
    batchToUpdateStatus: any;
    statusToUpdate: any;
    isOpen: boolean;
    onClose(): void;
    triggerReload(): void;
    setSwalProps: any;
}> = ({ isOpen, onClose, triggerReload, batchToUpdateStatus, statusToUpdate, setSwalProps }) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const userRole = localStorage.getItem("userRole")?.toLowerCase();

    const closeModal = async () => {
        onClose();
    };

    const displayStatus = () => {
        let statusLabel = "";
        switch (statusToUpdate) {
            case "in_progress":
                statusLabel = "IN PROGRESS";
                break;
            case "settled":
                statusLabel = "SETTLED";
                break;
            case "failed":
                statusLabel = "FAILED";
                break;
        }

        return statusLabel;
    };

    const handleSubmit = async () => {
        try {
            setIsProcessing(true);

            const postData = {
                id: batchToUpdateStatus.id,
                status: statusToUpdate,
                username: localStorage.getItem("username"),
                userRole: userRole,
                subaccount_id: batchToUpdateStatus.subaccount.id
            }

            await axios.post(process.env.REACT_APP_API_URL + `/api/${userRole}/batch/action/batch-update-status`, postData).then(function (response) {
                onClose();
                if (response && response.data?.status === 'ok') {
                    setSwalProps({
                        show: true,
                        icon: "success",
                        title: "Success",
                        html: "Batch status has been updated",
                        showConfirmButton: true,
                        didClose: () => {
                            triggerReload();
                            setSwalProps({});
                            setIsProcessing(false);
                        },
                    });
                } else {
                    setIsProcessing(false);
                }
            }).catch(function (error) {
                setIsProcessing(false);
                setSwalProps({
                    show: true,
                    icon: "error",
                    title: "Oops!",
                    html: error.response.data.message,
                    showConfirmButton: true,
                    didClose: () => {
                        setSwalProps({});
                        setIsProcessing(false);
                    },
                });
            });
        } catch (error: any) {
            setIsProcessing(false);
            setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: "Something went wrong, please try again later.",
                showConfirmButton: true,
                didClose: () => {
                    setSwalProps({});
                    setIsProcessing(false);
                },
            });
        }
    };

    return (
        <>
            {batchToUpdateStatus &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="dark:!bg-neutral-900 !z-[1002] !m-auto !w-full max-w-2xl !rounded-2xl !border !border-gray-200 !bg-white !shadow-xl dark:!border-white/10 md:!top-[12vh]">
                        <ModalBody className="p-6 md:p-7">
                            <div className="mb-4 flex items-start gap-3">
                                <div className="rounded-xl bg-primary-50 p-2 text-primary-600 ring-1 ring-primary-100 dark:bg-primary-900/20 dark:text-primary-400 dark:ring-primary-900/30">
                                    <svg
                                        viewBox="0 0 24 24"
                                        className="h-5 w-5"
                                        fill="currentColor"
                                    >
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                    </svg>
                                </div>
                                <div>
                                    <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                                        Update Batch Status
                                    </h1>
                                    <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                                        Change status to {displayStatus()}
                                    </p>
                                </div>
                            </div>

                            <div className="mb-4 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800 dark:border-blue-900/40 dark:bg-blue-900/20 dark:text-blue-300">
                                You're about to update the current batch status to <span className="font-semibold">{displayStatus()}</span>. This action cannot be undone.
                            </div>

                            <div className="dark:bg-neutral-800/50 mb-6 rounded-xl bg-gray-50 p-4 ring-1 ring-gray-100 dark:ring-white/10">
                                <div className="flex flex-col gap-3 text-sm">
                                    {userRole === 'superadmin' && batchToUpdateStatus.provider_name && batchToUpdateStatus.provider_account_name && batchToUpdateStatus.provider_method_name && (
                                        <>
                                            <div className="flex">
                                                <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                                    Provider
                                                </div>
                                                <div className="font-medium text-gray-900 dark:text-white">
                                                    {batchToUpdateStatus.provider_name} ({batchToUpdateStatus.provider_account_name})
                                                </div>
                                            </div>
                                            <div className="flex">
                                                <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                                    Provider Method
                                                </div>
                                                <div className="font-medium text-gray-900 dark:text-white">
                                                    {batchToUpdateStatus.provider_method_name}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <div className="flex">
                                        <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                            Record(s)
                                        </div>
                                        <div className="font-medium text-gray-900 dark:text-white">
                                            {batchToUpdateStatus.record}
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                            Amount
                                        </div>
                                        <div className="font-medium text-gray-900 dark:text-white">
                                            {batchToUpdateStatus.crypto ? batchToUpdateStatus.amount : <DisplayAmount amount={Number(batchToUpdateStatus.amount)} currency={batchToUpdateStatus.asset} />} {batchToUpdateStatus.asset}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-end gap-2">
                                <Button
                                    onClick={() => closeModal()}
                                    isDisabled={isProcessing}
                                    className="dark:bg-neutral-900 dark:hover:bg-neutral-800 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500/20 dark:border-white/10 dark:text-white"
                                >
                                    Not now
                                </Button>

                                <Button
                                    onClick={() => handleSubmit()}
                                    isDisabled={isProcessing}
                                    isLoading={isProcessing}
                                    loadingText='Processing...'
                                    className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/30 disabled:cursor-not-allowed disabled:bg-gray-400"
                                >
                                    Update batch
                                </Button>
                            </div>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default BatchUpdateStatusConfirmModal;